export default __webpack_public_path__ + "static/media/mint-button-2.b5048188.gif";